import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function MaSimulationResult({ customsimulationRate, simulationRate, setOpenSimulation }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(true)

  const [oldData, setOldData] = useState({})
  const formatCurrency = (value) =>
    new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    }).format(Number(value || 0))

  useEffect(() => {
    fetchCustomSimulation()
  }, [])

  // const handleClickOpen = () => {
  //   setOpen(true)
  // }

  const handleClose = () => {
    setOpen(false)

    setOpenSimulation(false)
  }

  const fetchCustomSimulation = async () => {
    const url = urls.getCustomSimulationResul
    const { data, status } = await makePostRequest(
      url,
      { ...customsimulationRate, simulationRate },
      {},
      true,
    )
    if (status === 200) {
      setOldData(data)
    }
  }

  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 10,
          color: 'rgba(255,255,255,0.72)',
          usePointStyle: true,
        },
      },
      tooltip: {
        backgroundColor: '#ffffff',
        titleColor: '#10233f',
        bodyColor: '#10233f',
        callbacks: {
          label: (context) => `${context.dataset.label}: ${formatCurrency(context.raw)}`,
          title: (items) => `${t('monPatrimoine.yearTooltip')} ${items?.[0]?.label || ''}`,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { color: 'rgba(255,255,255,0.06)' },
        ticks: { color: 'rgba(255,255,255,0.82)', maxRotation: 0 },
      },
      y: {
        stacked: true,
        grid: { color: 'rgba(255,255,255,0.08)' },
        ticks: {
          color: 'rgba(255,255,255,0.82)',
          callback: (value) => formatCurrency(value).replace('€', '').trim(),
        },
      },
    },
  }
  const chartColors = {
    Cash: '#d8e8f6',
    Fondsendevise: '#5aa1d8',
    Alternatifs: '#7cc6b2',
    Immobilier: '#2f8ee8',
    Actions: '#f2b84b',
    Matériel: '#a987ff',
    Dettes: '#ef6b6b',
  }
  const [data, setRevData] = useState({
    labels: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
    ],
    datasets: [
      // LAP-733 (GE022) — labels translated, then re-set on locale switch via useEffect deps
      {
        label: t('monPatrimoine.cashLabel'),
        data: [1, 2, 45, 45, 6, 48, 4, 5],
        backgroundColor: chartColors.Cash,
        borderColor: chartColors.Cash,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.fundInCurrency'),
        data: [1, 2, 45, 45, 6, 48, 4, 5],
        backgroundColor: chartColors.Fondsendevise,
        borderColor: chartColors.Fondsendevise,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.alternative'),
        data: [1, 2, 45, 45, 6, 48, 4, 5],
        backgroundColor: chartColors.Alternatifs,
        borderColor: chartColors.Alternatifs,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.realEstate'),
        data: [1, 2, 45, 45, 6, 48, 4, 5],
        backgroundColor: chartColors.Immobilier,
        borderColor: chartColors.Immobilier,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.shares'),
        data: [1, 2, 45, 45, 6, 48, 4, 5],
        backgroundColor: chartColors.Actions,
        borderColor: chartColors.Actions,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.material'),
        data: [1, 2, 45, 45, 6, 48, 4, 5],
        backgroundColor: chartColors.Matériel,
        borderColor: chartColors.Matériel,
        borderRadius: 4,
        barThickness: 12,
      },
    ],
  })
  useEffect(() => {
    let data_set = []
    if (oldData?.Assets?.Cash) {
      data_set.push({
        label: t('monPatrimoine.cashLabel'), // LAP-733 (GE022)
        data: oldData?.Assets?.Cash?.year,
        backgroundColor: chartColors.Cash,
        borderColor: chartColors.Cash,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Fondsendevise) {
      data_set.push({
        label: t('monPatrimoine.fundInCurrency'), // LAP-733 (GE022)
        data: oldData?.Assets?.Fondsendevise?.year,
        backgroundColor: chartColors.Fondsendevise,
        borderColor: chartColors.Fondsendevise,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Alternatifs) {
      data_set.push({
        label: t('monPatrimoine.alternative'), // LAP-733 (GE022)
        data: oldData?.Assets?.Alternatifs?.year,
        backgroundColor: chartColors.Alternatifs,
        borderColor: chartColors.Alternatifs,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Immobilier) {
      data_set.push({
        label: t('monPatrimoine.realEstate'), // LAP-733 (GE022)
        data: oldData?.Assets?.Immobilier?.year,
        backgroundColor: chartColors.Immobilier,
        borderColor: chartColors.Immobilier,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Actions) {
      data_set.push({
        label: t('monPatrimoine.shares'), // LAP-733 (GE022)
        data: oldData?.Assets?.Actions?.year,
        backgroundColor: chartColors.Actions,
        borderColor: chartColors.Actions,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Matériel) {
      data_set.push({
        label: t('monPatrimoine.material'), // LAP-733 (GE022)
        data: oldData?.Assets?.Matériel?.year,
        backgroundColor: chartColors.Matériel,
        borderColor: chartColors.Matériel,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Dettes) {
      data_set.push({
        label: t('monPatrimoine.debts'), // LAP-733 (GE022)
        data: oldData?.Assets?.Dettes?.year,
        backgroundColor: chartColors.Dettes,
        borderColor: chartColors.Dettes,
        borderRadius: 4,
        barThickness: 12,
      })
    }

    setRevData({
      labels: Array.from({ length: 20 }, (_, i) => `${i + 1}`),
      datasets: data_set,
    })
    // LAP-733 (GE022) — refresh dataset labels on locale switch
  }, [oldData, i18n.language])
  const VerticalBarChart = () => (
    <>
      <Bar data={data} options={optionsbar} />
    </>
  )
  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        className="no-drag"
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', bgcolor: '#061f3d' } }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 0, right: 0 }}
          aria-label="fingerprint"
          color="secondary"
        >
          <CloseIcon sx={{ color: 'white' }} />
        </IconButton>
        <DialogTitle sx={{ color: 'white !important', bgcolor: '#061f3d', pb: 1 }}>
          {t('monPatrimoine.simulationResultTitle')}
          <Typography sx={{ color: 'rgba(255,255,255,0.64)', fontSize: 14, mt: 0.5 }}>
            {t('monPatrimoine.simulationResultSubtitle')}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ bgcolor: '#061f3d', pt: 1 }}>
          <Stack direction="row" gap={1} flexWrap="wrap" sx={{ mb: 2 }}>
            <Box sx={{ p: 1.4, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.08)', minWidth: 150 }}>
              <Typography sx={{ color: 'rgba(255,255,255,0.58)', fontSize: 12 }}>{t('monPatrimoine.today')}</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 850 }}>{formatCurrency(oldData?.meta?.initial_total)}</Typography>
            </Box>
            <Box sx={{ p: 1.4, borderRadius: 2, bgcolor: 'rgba(47,142,232,0.18)', minWidth: 150 }}>
              <Typography sx={{ color: 'rgba(255,255,255,0.58)', fontSize: 12 }}>{t('monPatrimoine.in20Years')}</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 850 }}>{formatCurrency(oldData?.meta?.final_total)}</Typography>
            </Box>
            <Box sx={{ p: 1.4, borderRadius: 2, bgcolor: 'rgba(124,198,178,0.18)', minWidth: 150 }}>
              <Typography sx={{ color: 'rgba(255,255,255,0.58)', fontSize: 12 }}>{t('monPatrimoine.growth')}</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 850 }}>{formatCurrency(oldData?.meta?.gain)}</Typography>
            </Box>
          </Stack>
          <Box
            display={'flex'}
            bgcolor={'rgba(0, 0, 29, 0.38)'}
            borderRadius={2}
            border={'1px solid rgba(255,255,255,0.08)'}
          >
            <Box width={'100%'} p={2} height={460}>
              <VerticalBarChart />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  )
}
